import { render, staticRenderFns } from "./AtlasPage.vue?vue&type=template&id=71352789&scoped=true"
import script from "./AtlasPage.vue?vue&type=script&lang=js"
export * from "./AtlasPage.vue?vue&type=script&lang=js"
import style0 from "./AtlasPage.vue?vue&type=style&index=0&id=71352789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71352789",
  null
  
)

export default component.exports